import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Link } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 4
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
};

const ComplexityColorMapping = {
  Low: "#63B954",        // Beginner
  Medium: "#6B5200",     // Intermediate
  High: "#A72020",       // Advanced
};

const labelMapping = {
  All: "All",
  Low: "Beginner",
  Medium: "Intermediate",
  High: "Advanced",
};

const CustomRightArrow = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right"
      aria-label="Next Slide"
      type="button"
    >
    </button>
  );
};

const CustomLeftArrow = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left"
      aria-label="Previous Slide"
      type="button"
    >
    </button>
  );
};


export const Carasole = ({ tasks, IMAGE_PATH}) => {
  
  // new Code for useNavigate
  // const navigate = useNavigate()
  
  // new code for useNavigate
  // const handleNavigation  = (task) =>{
  //   navigate(`/collabwithgov/detail/${task.artifact_id}`, { state: { task } });
  // }

    return (
        <>
            <Carousel
                responsive={responsive}        
                customRightArrow={<CustomRightArrow />}
                customLeftArrow={<CustomLeftArrow />}
            >

          {
            tasks.map((task, index) => { 
              let publishedDate = '';
              if(task && task.submitted_on !== undefined && task.submitted_on !== ''){
                  // Convert UNIX timestamp to a JavaScript Date object
                  let submittedDate = new Date(task.submitted_on * 1000);
          
                  let day = submittedDate.getDate();
                  //let month = submittedDate.toLocaleString('en-US', { month: 'short' }).toUpperCase();
                  let month = submittedDate.toLocaleString('en-US', { month: 'short' });
                  month = month.charAt(0).toUpperCase() + month.slice(1).toLowerCase();
                  publishedDate = `${day} ${month}`;
              }

              let submittedDateFormatted = '';
            if (task && task.hasOwnProperty('last_submission_date_1')) {
                let Last_Submission_Date = task?.last_submission_date_1?.value?.[0];
                let submittedDate = new Date(Last_Submission_Date);

                // Extract day, month (in short form and uppercase), and year
                let day = submittedDate.getDate();
                //let month = submittedDate.toLocaleString('en-US', { month: 'short' }).toUpperCase();
                let month = submittedDate.toLocaleString('en-US', { month: 'short' });
                month = month.charAt(0).toUpperCase() + month.slice(1).toLowerCase();
                let year = submittedDate.getFullYear();

                // Format the date as "DD MON YYYY"
                submittedDateFormatted = `${day} ${month} , ${year}`;
            }
          
            return (
              <div className="card" key={index}
              // new code for useNavigate 
              // onClick={()=>handleNavigation(task)}
              // style={{ cursor: "pointer" }} 
              >   
              {/* previous code      */}
                <Link to={`/collabwithgov/detail/${task.artifact_id}`}
              style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="badge">
                {
                  (task.hasOwnProperty('category') && (task.category.value) && (task.category.value.length > 0))?task.category.value.map((category, idx) => (
                    <span key={`category-${idx}`}>{category}</span>
                  )):''
                }  
                </div>
                <div className="title">
                {
                      (task.hasOwnProperty('title') && (task.title.value) && (task.title.value.length > 0))?task.title.value.slice(0,1).map((title, idx) => (
                          <span key={`title-${idx}`}>{title}</span>
                      )):''
                }
                </div>
                <div className="date">
                  <img
                    src={`${IMAGE_PATH}/calendar_today.png`}
                    style={{ verticalAlign: 'bottom' }}
                    alt="calendar_today.png"
                  />{' '}
                  {publishedDate} - {submittedDateFormatted}
                </div>
                <div className="complexity">Complexity Level: 
                {
                  (task.hasOwnProperty('complexity') && (task.complexity.value) && (task.complexity.value.length > 0))?task.complexity.value.slice(0,1).map((level, idx) => (
                    <span   style={{color: ComplexityColorMapping[level?.trim()]}} key={`level-${idx}`}>{labelMapping[level?.trim()]}</span>
                  )):''
                }  
                </div>
                <div className="tags">
                {
                      (task.hasOwnProperty('skills_and_expertise') &&(task.skills_and_expertise.value) && (task.skills_and_expertise.value.length > 0))?task.skills_and_expertise.value.slice(0,1).map((skill, idx) => (
                          <div className="tag" key={`skill-${idx}`}>{skill}</div>
                      )):''
                  }  
                  </div>
                {/* previous code */}
                </Link>
              </div>
            )})
          }
          </Carousel>
        </>
    )
}